import { useLayoutEffect, useRef, useState, type ReactNode } from 'react';
import './phone.css';

/** Fits the unchanged glasses composition inside the phone's safe, visible viewport. */
export default function PhoneStage({ children }: { children: ReactNode }) {
  const space = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(0);
  const viewport = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    document.documentElement.classList.add('phone-layout');
    const visible = window.visualViewport;
    const fit = () => {
      if (!viewport.current || !space.current) return;
      viewport.current.style.width = `${visible?.width ?? window.innerWidth}px`;
      viewport.current.style.height = `${visible?.height ?? window.innerHeight}px`;
      viewport.current.style.top = `${visible?.offsetTop ?? 0}px`;
      viewport.current.style.left = `${visible?.offsetLeft ?? 0}px`;
      setScale(Math.min(space.current.clientWidth, space.current.clientHeight, 600) / 600);
    };
    const observer = new ResizeObserver(fit);
    if (space.current) observer.observe(space.current);
    window.addEventListener('resize', fit);
    visible?.addEventListener('resize', fit);
    visible?.addEventListener('scroll', fit);
    fit();
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', fit);
      visible?.removeEventListener('resize', fit);
      visible?.removeEventListener('scroll', fit);
      document.documentElement.classList.remove('phone-layout');
    };
  }, []);
  return <div ref={viewport} className="phone-viewport">
    <div ref={space} className="phone-space">
      <div className="phone-stage" style={{ transform: `translate(-50%, -50%) scale(${scale})` }}>{children}</div>
    </div>
  </div>;
}
